export default defineComponent({
  setup: function setup() {}
});